<template>
  <v-footer
    app
    :absolute="$vuetify.breakpoint.smAndDown"
    elevation="5"
  >
    <!-- 모바일 -->
    <template v-if="$vuetify.breakpoint.smAndDown">
      <v-row justify="center" no-gutters>
        <v-col cols="12" style="font-size:0.65rem" class="text-center">(13553) 경기도 성남시 분당구 분당수서로 477, 9층 (정자동, GRC 센터)</v-col>
        <v-col cols="12" style="font-size:0.65rem" class="text-center">Copyrights ⓒ HD Hyundai Energy Solutions Co.,Ltd.All Rights Reserved.</v-col>
      </v-row>
    </template>
    <!-- PC -->
    <template v-else>
      <v-avatar :tile="true" height="30" width="130">
        <img :src="require('@/assets/image/pc/fot_logo_03.png')" alt="logo">
      </v-avatar>
      <div class="ml-5">
        <p class="mb-0 caption">(13553) 경기도 성남시 분당구 분당수서로 477, 9층 (정자동, GRC 센터)</p>
        <p class="mb-0 caption">Copyrights ⓒ HD Hyundai Energy Solutions Co.,Ltd.All Rights Reserved.</p>
      </div>
    </template>
  </v-footer>
</template>
<script>
export default {
  name: 'AppFooter'
}
</script>
<style>
.v-footer--fixed {
  z-index: 5 !important;
}
</style>
